import { ref } from 'vue'

import { login } from '@js/api/auth/login'
import { authLinks } from '@js/utils/links'
import useCart from '@js/composables/useCart'

import { Customer } from '@js/api/types/customer/Customer'

export default function useAuth() {
  const { clearCart } = useCart()

  const isLoggedIn = ref(false)
  const token = localStorage.getItem('authToken')

  if (token) {
    const { expiration } = JSON.parse(token) as { expiration: string, token: string }

    if (Date.now() > Date.parse(expiration)) {
      localStorage.removeItem('authToken')

      clearCart()

      isLoggedIn.value = false
    } else {
      isLoggedIn.value = true
    }
  } else {
    clearCart()
  }

  const getAuthUser = (): Customer | null => {
    const user = localStorage.getItem('user')

    return user ? JSON.parse(user) : null
  }

  const logInUser = async (payload: { email: string, password: string }): Promise<void> => {
    await login({
      email: payload.email,
      password: payload.password,
    })
  }

  const logout = (): void => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('registrationId')
    localStorage.removeItem('user')

    clearCart()

    isLoggedIn.value = false

    window.location.assign(authLinks.LOGIN)
  }

  const getLastRegistration = (): number | null => {
    const id = localStorage.getItem('registrationId')
    if (!id || id === 'undefined') {
      if (id === 'undefined') localStorage.removeItem('registrationId')
      return null
    }
    try {
      return JSON.parse(id)
    } catch {
      localStorage.removeItem('registrationId')
      return null
    }
  }

  const setLastRegistration = (id: number): void => {
    localStorage.setItem('registrationId', JSON.stringify(id))
  }

  return {
    logout,
    logInUser,
    isLoggedIn,
    getAuthUser,
    getLastRegistration,
    setLastRegistration,
  }
}
